/* ============================================================
   IDEAS CAFE — <ideas-open-now>

   Resolves an open/closed badge from a machine-readable hours
   string, in the VISITOR's clock, at view time. A hardcoded badge
   would be wrong for most of the day.

   Format:  "mon-thu:11:00-24:00; fri:12:00-25:00; sat-sun:11:00-25:00"

   Hours past 24:00 mean "after midnight, next day" — the cafe's
   1am close is 25:00, which keeps a single range per day instead of
   splitting every late night into two entries.

   The element stays hidden until it has resolved, so a visitor with
   JS disabled sees no badge rather than a wrong one.
   ============================================================ */
(function () {
  'use strict';

  if (customElements.get('ideas-open-now')) return;

  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  function parseRanges(spec) {
    // → { 0: [[start,end]], 1: [...] } with minutes-from-midnight
    var byDay = {};

    String(spec || '')
      .split(';')
      .forEach(function (chunk) {
        var part = chunk.trim();
        if (!part) return;

        var split = part.indexOf(':');
        if (split < 0) return;

        var dayPart = part.slice(0, split).trim().toLowerCase();
        var timePart = part.slice(split + 1).trim();

        var times = timePart.split('-');
        if (times.length !== 2) return;

        var open = toMinutes(times[0]);
        var close = toMinutes(times[1]);
        if (open === null || close === null) return;

        expandDays(dayPart).forEach(function (dayIndex) {
          (byDay[dayIndex] = byDay[dayIndex] || []).push([open, close]);
        });
      });

    return byDay;
  }

  function toMinutes(hhmm) {
    var m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm).trim());
    if (!m) return null;
    return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
  }

  function expandDays(spec) {
    var out = [];
    spec.split(',').forEach(function (token) {
      var range = token.trim().split('-');
      var from = DAYS.indexOf(range[0]);
      if (from < 0) return;

      if (range.length === 1) {
        out.push(from);
        return;
      }

      var to = DAYS.indexOf(range[1]);
      if (to < 0) return;

      // Wraps the week when the range crosses Sunday (e.g. sat-sun,
      // or fri-mon).
      var i = from;
      out.push(i);
      while (i !== to) {
        i = (i + 1) % 7;
        out.push(i);
      }
    });
    return out;
  }

  function isOpen(byDay, now) {
    var day = now.getDay();
    var minutes = now.getHours() * 60 + now.getMinutes();

    // Today's own ranges.
    var today = byDay[day] || [];
    for (var i = 0; i < today.length; i++) {
      if (minutes >= today[i][0] && minutes < today[i][1]) return true;
    }

    // Yesterday's range may still be running past midnight — a 25:00
    // close means 1am belongs to yesterday's session.
    var prev = byDay[(day + 6) % 7] || [];
    for (var j = 0; j < prev.length; j++) {
      if (prev[j][1] > 1440 && minutes < prev[j][1] - 1440) return true;
    }

    return false;
  }

  class IdeasOpenNow extends HTMLElement {
    connectedCallback() {
      var label = this.querySelector('[data-status-label]');
      if (!label) return;

      var byDay = parseRanges(this.dataset.hours);
      if (!Object.keys(byDay).length) return;

      var open = isOpen(byDay, new Date());

      label.textContent = open
        ? this.dataset.labelOpen || 'Open now'
        : this.dataset.labelClosed || 'Closed';

      this.classList.toggle('is-open', open);
      this.classList.toggle('is-closed', !open);
      this.hidden = false;
    }
  }

  customElements.define('ideas-open-now', IdeasOpenNow);
})();
